import React, { useState, useCallback, useMemo } from "react";
import SearchOrder from "./SearchOrder";
import OrderDetails from "./OrderDetails";
import { normalizeOrderForPacking } from "./utils/normalizeOrder";
import dummySalesOrder from "./dummy/dummySalesOrder"; // your provided JSON as JS export

export default function InitiatePackingManagement() {
  const [activeScreen, setActiveScreen] = useState("SEARCH"); // SEARCH | ORDER_DETAILS
  const [recentOrders, setRecentOrders] = useState([]);
  const [orderHeader, setOrderHeader] = useState(null);
  const [tableData, setTableData] = useState({});
  const [totalLines, setTotalLines] = useState(0);
  const [scannedSet, setScannedSet] = useState(() => new Set());

  const pushHistory = useCallback((id) => {
    setRecentOrders(prev => {
      const without = prev.filter(o => o !== id);
      return [id, ...without].slice(0, 20);
    });
  }, []);

  // simulate API: on search -> normalize dummy and go to details
  const handleOrderSearched = useCallback(async (orderId) => {
    if (!orderId) return;
    pushHistory(orderId);

    // TODO: replace with real API call
    const data = dummySalesOrder;

    const { header, table, lineCount } = normalizeOrderForPacking(data);
    setOrderHeader(header);
    setTableData(table);
    setTotalLines(lineCount);
    setScannedSet(new Set()); // reset scan state for new order
    setActiveScreen("ORDER_DETAILS");
  }, [pushHistory]);

  // scanner: mark one SKU as scanned
  const markScanned = useCallback((skuId) => {
    setScannedSet(prev => {
      const next = new Set(prev);
      next.add(String(skuId));
      return next;
    });
  }, []);

  const handleBack = useCallback(() => {
    setActiveScreen("SEARCH");
    setOrderHeader(null);
    setTableData({});
    setTotalLines(0);
    setScannedSet(new Set());
  }, []);

  const canPartial = useMemo(() => scannedSet.size > 0, [scannedSet.size]);
  const canComplete = useMemo(() => totalLines > 0 && scannedSet.size === totalLines, [scannedSet.size, totalLines]);

  return (
    <div className="container-fluid px-0 h-100">
      <div className="card shadow-lg main-card d-flex flex-column h-100">
        <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
          <h4 className="mb-0 h6 fw-semibold">
            {activeScreen === "SEARCH" ? "Packing Station" : "Order Details"}
          </h4>
        </div>

        <div className="card-body flex-grow-1 overflow-auto">
          {activeScreen === "SEARCH" ? (
            <SearchOrder onSearched={handleOrderSearched} recentOrders={recentOrders} />
          ) : (
            <OrderDetails
              header={orderHeader}
              tableData={tableData}
              scannedSet={scannedSet}
              totalLines={totalLines}
              onScanSuccess={markScanned}
              onBack={handleBack}
              canPartial={canPartial}
              canComplete={canComplete}
            />
          )}
        </div>
        {/* NOTE: Footer removed from wrapper — now lives inside OrderDetails */}
      </div>
    </div>
  );
}
